import { ConnectionOptions, GraphApiMethod } from '@/api/core';
import {
  DeleteTripDocumentBulkInput,
  DeleteTripDocumentBulkResponse,
  DeleteTripDocumentInput,
  MutationDeleteTripDocumentBulkArgs,
} from '@/models/gen/graphql';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { TypedDocumentNode } from '@apollo/client';
import { getProperty } from '@/utils';
import graphApi from '@/api';
import { DeleteTripDocumentBulk } from '@/features/Trips/api/queries/DeleteTripDocumentBulk';

// Service Function Signature
type ServiceMethodPayload = {
  [key in keyof DeleteTripDocumentInput]?: any;
}[];
interface ServiceMethod {
  (payload?: ServiceMethodPayload, options?: ConnectionOptions): Promise<DeleteTripDocumentBulkResponse>;
}

// DeleteTripDocumentBulk Service
export const { deleteTripDocumentBulk, useDeleteTripDocumentBulk } = ((): {
  deleteTripDocumentBulk: ServiceMethod;
  useDeleteTripDocumentBulk: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [fetch] = graphApi(DeleteTripDocumentBulk).map(
    (fn: GraphApiMethod<TypedDocumentNode>): ServiceMethod =>
      async (payload?: DeleteTripDocumentInput[], options?: ConnectionOptions): Promise<DeleteTripDocumentBulkResponse> => {
        const args: MutationDeleteTripDocumentBulkArgs = {
          input: {
            search: payload,
          },
        };
        const opts = { merge: options?.merge ? 'deleteTripDocumentBulk' : undefined };
        const res = await fn(args, opts);
        return getProperty('deleteTripDocumentBulk', res);
      }
  );
  const useService = createGraphApiHook(fetch);
  return {
    deleteTripDocumentBulk: fetch,
    useDeleteTripDocumentBulk: useService,
  };
})();
